import { render } from "./ComplementoPrivacidad.vue?vue&type=template&id=b603d998"
import script from "./ComplementoPrivacidad.vue?vue&type=script&lang=js"
export * from "./ComplementoPrivacidad.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/congreso_online/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__